export default __webpack_public_path__ + "static/media/wellgrowerKo1.5406f86e.svg";